module.exports = __webpack_public_path__ + "img/camus.53350ddf.jpg";